<script>
  import _base from '../../_default/components/_base.vue'

  export default{
    name: 'Logs',
    extends: _base,
    data () {
      return {}
    },
    computed: {},
    mounted () {
//      this._menuFolded(true)
    },
    destroyed () {},
    methods: {},
    components: {}
  }
</script>

<template>
    <div class="app-content">

        <div class="app-content-body leiloes">
            <router-view></router-view>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// Main.vue?6fb4059a